import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '@/features/operations/settings';

export const Route = createFileRoute('/operations/settings')({
  component: OperationsSettingsRoute,
});

function OperationsSettingsRoute() {
  return <SettingsPage />;
}
